export const getInitialsFromEmail = (email) => {
    if (!email) return '?';
    const localPart = String(email).split('@')[0] || '';
    const first = localPart.charAt(0) || '';
    const dotIndex = localPart.indexOf('.');
    const second = dotIndex > -1 && localPart.charAt(dotIndex + 1)
        ? localPart.charAt(dotIndex + 1)
        : (localPart.charAt(1) || '');
    return (first + second).toUpperCase();
};

const isImageUrl = async (url) => {
    try {
        const response = await fetch(url, { method: 'HEAD' });
        if (!response.ok) return false;
        const contentType = response.headers.get('content-type') || '';
        return contentType.startsWith('image/');
    } catch (e) {
        // CORS ou autre erreur réseau: on ne peut pas conclure → laisser le composant gérer via <img onError>
        return null; // inconnu
    }
};

export const resolveAvatar = async (email) => {
    const url = `${process.env.REACT_APP_URL_SSO}/avatar/${email}`;
    const result = await isImageUrl(url);
    if (result === true) {
        return { type: 'image', src: url };
    }
    if (result === false) {
        return { type: 'initials', text: getInitialsFromEmail(email) };
    }
    // result === null (inconnu/CORS): tenter l'image, basculer via onError côté composant
    return { type: 'unknown', src: url, text: getInitialsFromEmail(email) };
};


